<script lang="ts">import { banerFixedData } from "./constants/banners";
const data = banerFixedData;
</script>

<div class="banner-wrapper">
	<div class="banner-card-list">
		{#each data as item (item.imgPath)}
			<div class="card">
				<img class="card-image" src={item.imgPath} alt="" />
				<div class="card-content">
					<div class="card-text-group">
						<div
							style="color: {item.subTextColor};background-color: {item.subBgColor};"
							class="card-tag"
						>
							<div class="card-tag-text">{item.subTitle}</div>
						</div>
						<div class="card-title">
							<!-- eslint-disable-next-line svelte/no-at-html-tags -- title comes from the static, in-repo banerFixedData constant, not user input -->
							{@html item.title}
						</div>
					</div>
					<button class="card-button">
						<div class="card-button-text">
							{item.actionName}
						</div>
					</button>
				</div>
			</div>
		{/each}
	</div>
</div>

<style>
	.banner-wrapper {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    width: 105%;
    overflow-x: auto
}
	@media (min-width: 768px) {
    .banner-wrapper {
        margin-top: 0px;
        margin-bottom: 0.5rem;
        width: 100%
    }
}

	.banner-card-list {
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    gap: 1rem
}

	@media (min-width: 768px) {
    .banner-card-list {
        width: 100%
    }
}

	.card {
    position: relative;
    height: 100%;
    min-height: 185px;
    width: 100%;
    min-width: 88vw;
    align-self: stretch;
    overflow: hidden;
    border-radius: 1rem;
    background-color: var(--color-background-500)
}

	@media (min-width: 768px) {
    .card {
        min-width: unset
    }
}

	.card-image {
    position: absolute;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center
}

	.card-content {
    position: absolute;
    left: 20px;
    top: 30px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1rem
}

	.card-text-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.625rem
}

	.card-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border-radius: 3px;
    padding: 0.25rem
}

	.card-tag-text {
    justify-content: flex-start;
    font-size: 8px;
    font-weight: 700;
    line-height: 9px
}

	.card-title {
    justify-content: flex-end;
    font-size: 1.5rem;
    font-weight: 800;
    text-transform: uppercase;
    line-height: 1.5rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    text-shadow: 0px 3px 3px rgb(0 0 0 / 0.36)
}

	.card-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border-radius: 0.5rem;
    padding: 0.75rem;
    outline-style: solid;
    outline-width: 1px;
    outline-offset: -1px;
    outline-color: var(--component-banner-swiper-banner-fixed-regular-color);
    --tw-backdrop-blur: blur(13px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}

	.card-button-text {
    justify-content: flex-start;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    line-height: 14px;
    color: var(--component-banner-swiper-banner-fixed-regular-color)
}
</style>
